import { IOption } from '../../interfaces/FormFields'

export const PatrimonyTypes: IOption[] = [
  {
    value: '',
    label: 'Sélectionner',
  },
  {
    value: 'Biens immobiliers',
    label: 'Biens immobiliers',
  },
  {
    value:
      'Avoirs financiers (liquidités, comptes courants, épargne, comptes titres, PEA, assurance vie…)',
    label:
      'Avoirs financiers (liquidités, comptes courants, épargne, comptes titres, PEA, assurance vie…)',
  },
  {
    value: 'Autres biens (biens mobiliers, oeuvres d’art…)',
    label: 'Autres biens (biens mobiliers, oeuvres d’art…)',
  },
]
